module.exports = __webpack_public_path__ + "img/verneplanforvassdrag.7efd026a.jpg";